<!-- Mobile Backdrop -->
@if (layoutService.isMobileSidebarOpen()) {
<div class="fixed inset-0 bg-gray-900/50 z-30 md:hidden backdrop-blur-sm transition-opacity"
    (click)="layoutService.closeMobileSidebar()"></div>
}

<aside
    class="fixed top-0 left-0 z-40 h-screen pt-20 transition-transform duration-300 bg-white border-r border-gray-100 -translate-x-full md:translate-x-0 w-64"
    [class.translate-x-0]="layoutService.isMobileSidebarOpen()"
    [class.md:w-20]="layoutService.isDesktopSidebarCollapsed()"
    [class.md:w-64]="!layoutService.isDesktopSidebarCollapsed()" aria-label="Sidebar">
    <div class="h-full px-3 pb-4 bg-white flex flex-col">
        <div class="flex-1 pb-6"
            [class.overflow-y-auto]="!isCollapsed()"
            [class.scrollbar-hide]="!isCollapsed()"
            [class.overflow-visible]="isCollapsed()">
            <ul class="space-y-2 font-medium">
            @for (item of menuItems(); track item.label) {
            <li class="relative group/menu-item">
                @if (item.children) {
                <!-- Parent Item with Children -->
                <button (click)="toggleSubMenu(item)"
                    class="w-full flex items-center p-3 text-text-muted rounded-r-xl hover:bg-gray-100 group transition-all duration-300 border-l-4 border-transparent">
                    <span class="w-6 h-6 flex-shrink-0 transition-all duration-300 group-hover:text-primary"
                        [innerHTML]="item.icon | safeHtml"></span>
                    @if (!isCollapsed()) {
                    <span class="ms-1 font-bold tracking-tight flex-1 text-left leading-tight px-1">{{ item.label
                        }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg"
                        class="w-4 h-4 transition-transform duration-300 me-2 flex-shrink-0"
                        [class.rotate-180]="isMenuOpen(item)" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" />
                    </svg>
                    }
                </button>

                <!-- Tooltip for Parent Menu Item (Visible on hover only when collapsed and dropdown is NOT open) -->
                @if (isCollapsed() && !isMenuOpen(item)) {
                <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-3 py-1.5 bg-gray-900 text-white text-xs font-bold rounded-lg shadow-lg whitespace-nowrap opacity-0 pointer-events-none group-hover/menu-item:opacity-100 group-hover/menu-item:translate-x-1 transition-all duration-300 z-50">
                    {{ item.label }}
                </div>
                }

                @if (isMenuOpen(item) && !isCollapsed()) {
                <ul class="mt-1 space-y-1 ps-10 animate-in slide-in-from-top-2 duration-300 text-left">
                    @for (child of item.children; track child.path) {
                    <li>
                        <a [routerLink]="child.path" (click)="onChildClick(item)"
                            routerLinkActive="active-link text-primary font-extrabold bg-primary/50 rounded-lg"
                            [routerLinkActiveOptions]="{ exact: true }"
                            class="block p-2 text-sm text-text-muted hover:text-primary hover:bg-gray-50 transition-all duration-200 rounded-lg">
                            {{ child.label }}
                        </a>
                    </li>
                    }
                </ul>
                }

                <!-- Floating Submenu (Visible on click only when collapsed) -->
                @if (isCollapsed() && isMenuOpen(item)) {
                <div class="absolute left-full top-0 pl-2 w-54 z-50 animate-in fade-in slide-in-from-left-1 duration-150">
                    <div class="bg-white border border-gray-100 shadow-[0_10px_30px_rgba(0,0,0,0.08)] rounded-2xl py-2">
                        <div class="px-4 py-2 border-b border-gray-50 mb-1">
                            <span class="text-xs font-extrabold text-text-main uppercase tracking-wider">{{ item.label }}</span>
                        </div>
                        <ul class="space-y-0.5 px-2">
                            @for (child of item.children; track child.path) {
                            <li>
                                <a [routerLink]="child.path" (click)="onChildClick(item)"
                                    routerLinkActive="active-link text-primary font-extrabold bg-primary/10 rounded-lg"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    class="block px-3 py-2 text-sm text-text-muted hover:text-primary hover:bg-gray-50 transition-all duration-200 rounded-lg">
                                    {{ child.label }}
                                </a>
                            </li>
                            }
                        </ul>
                    </div>
                </div>
                }
                } @else {
                <!-- Regular Link -->
                <a [routerLink]="item.path" (click)="layoutService.closeMobileSidebar()"
                    routerLinkActive="active-link bg-primary/50 text-primary border-l-4 border-primary-dark"
                    [routerLinkActiveOptions]="{exact: true}"
                    class="flex items-center p-3 text-text-muted rounded-r-xl hover:bg-gray-100 group transition-all duration-300 border-l-4 border-transparent relative">
                    <span
                        class="w-6 h-6 flex-shrink-0 transition-all duration-300 group-[.active-link]:text-primary-dark group-hover:text-primary"
                        [innerHTML]="item.icon | safeHtml"></span>
                    @if (!isCollapsed()) {
                    <span class="ms-1 font-bold tracking-tight text-left flex-1 leading-tight px-1">{{ item.label
                        }}</span>
                    }
                </a>

                <!-- Tooltip for Regular Link (Visible on hover only when collapsed) -->
                @if (isCollapsed()) {
                <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-3 py-1.5 bg-gray-900 text-white text-xs font-bold rounded-lg shadow-lg whitespace-nowrap opacity-0 pointer-events-none group-hover/menu-item:opacity-100 group-hover/menu-item:translate-x-1 transition-all duration-300 z-50">
                    {{ item.label }}
                </div>
                }
                }
            </li>
            }
            </ul>
        </div>

        <div class="w-full hidden md:block pt-2">
            <button (click)="toggleCollapse()"
                class="flex items-center justify-center w-full p-2 text-gray-500 rounded-lg hover:bg-gray-100 transition-all duration-200">
                <svg class="w-6 h-6 transition-transform duration-300" [class.rotate-180]="isCollapsed()" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                </svg>
            </button>
        </div>
    </div>
</aside>
